export const EditorEvents = {
    AddTemplatesToCampaign: "addTemplatesToCampaign"
} as const;
